import type { Category } from '../../types/models';

interface CategoryIconProps {
  category: Category;
  className?: string;
}

const PATHS: Record<Category, string> = {
  hifi: 'M4 17a8 8 0 0116 0M7 20a5 5 0 0110 0M12 4v2m0 10a2 2 0 100-4 2 2 0 000 4z',
  smartphone: 'M8 3h8a1 1 0 011 1v16a1 1 0 01-1 1H8a1 1 0 01-1-1V4a1 1 0 011-1zM11 18h2',
  laptop: 'M4 5h16v10H4V5zM2 19h20l-2-3H4l-2 3z',
  camera: 'M4 8h3l1.5-2h7L17 8h3v11H4V8zM12 12.5a3 3 0 100 6 3 3 0 000-6z',
  'smart-home': 'M4 11l8-7 8 7M6 10v10h12V10',
  gaming: 'M7 9h10a4 4 0 014 4v0a3 3 0 01-5.5 1.7L14 13h-4l-1.5 1.7A3 3 0 013 13v0a4 4 0 014-4z M8 11v2M7 12h2M15.5 12h.01M17.5 10.5h.01',
  car: 'M4 16V11l2-4h12l2 4v5M3 16h18M7 16a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM20 16a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z',
  ebike: 'M5 18a3 3 0 100-6 3 3 0 000 6zM19 18a3 3 0 100-6 3 3 0 000 6zM5 15l4-7h5l3 5M9 8h5M12 15h7',
  watch: 'M8 6l1-3h6l1 3M8 18l1 3h6l1-3M7 6h10v12H7V6zM12 9v3l2 1',
  other: 'M4 7l8-4 8 4-8 4-8-4zM4 7v10l8 4M20 7v10l-8 4M4 17l8-4 8 4',
};

export function CategoryIcon({ category, className = 'w-5 h-5' }: CategoryIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d={PATHS[category]} />
    </svg>
  );
}
